
import React, { useEffect } from 'react';
import './app.b5a6c92b7a2fd023b7a1.css';

   //app configuration
window.jsWebAppConfig = {
    containerId: 'app-container',
    cacheBreak: '<%= Date.now().toString() %>',
    appPath: '/resources/scripts/impact/static/',
    assetPath: '/resources/scripts/impact/static/',
    analytics: ({
        action /* string */ ,
        category /* string */ ,
        value /* ?string */
    }) => {
        console.log(
            `ANALYTICS STUB: action: ${action}, category: ${category}${value !== undefined ? `, value: ${value}`:''}`
            )
    }
};

const ImpactHub = ({ cms }) => {
    let impactScriptMounted = false
    useEffect(() => {        
            // run impact if loaded
            if( window.impactHubStartup && !impactScriptMounted){
                window.impactHubStartup()
                impactScriptMounted = true;
            }
      }, []);

   return (
      <React.Fragment>
         <div id="app-container" >
            
         </div>
      </React.Fragment>
   );
}
 
export default ImpactHub;
